module.exports = "img/photo9.070c88.jpg";